export default __webpack_public_path__ + "static/media/photo_restoration.c563eeaf.jpg";